import { DislikeOutlined, LikeOutlined } from "@ant-design/icons"
import { Popconfirm, Space, Input, message, Typography } from "antd"
import { arrayUnion, doc, updateDoc } from "firebase/firestore"
import React, { useState } from "react"
import { db } from "../../../firebase/config"
import { useAuthContext } from "../../../hooks/useAuthContext"

const { Text } = Typography
const { TextArea } = Input

export default function AcceptOrDeny({ record }) {
  const { user } = useAuthContext()
  const [adminComment, setAdminComment] = useState("")

  const confirm = (e) => {
    denyRequest(e)
  }

  const approveDoc = async (e) => {
    e.preventDefault()
    const ref = doc(db, "priceCalculation", record.id)
    // Use the client's current time; be cautious as this depends on the client's clock
    const newAdminRequest = {
      requestDate: new Date(),
      requestComment: "APPROVED BY " + user.email,
      requestedById: user.uid,
      requestedBy: user.email,
      role: "admin",
    }

    await updateDoc(ref, {
      adminRequested: false,
      adminRequestStatus: 0,
      adminRequests: arrayUnion(newAdminRequest),
    })
      .then(() => {
        message.success("Approved!")
      })
      .catch((err) => {
        message.error("Error!")
        console.error(err)
      })
  }

  //deny
  const denyRequest = async (e) => {
    e.preventDefault()
    const ref = doc(db, "priceCalculation", record.id)
    // Use the client's current time; be cautious as this depends on the client's clock
    const newAdminRequest = {
      requestDate: new Date(),
      requestComment: adminComment,
      requestedById: user.uid,
      requestedBy: user.email,
      role: "admin",
    }

    await updateDoc(ref, {
      adminRequestStatus: 1,
      adminRequests: arrayUnion(newAdminRequest),
    })
      .then(() => {
        message.success("Sent away!")
      })
      .catch((err) => {
        message.error("Error!")
        console.error(err)
      })
  }

  //return description
  const description = () => {
    return (
      <Space direction="vertical">
        <Text>Comment upon deny</Text>
        <TextArea
          value={adminComment}
          style={{ width: 300 }}
          onChange={(e) => setAdminComment(e.target.value)}
        />
      </Space>
    )
  }

  return (
    <>
      <Space>
        <LikeOutlined
          onClick={(e) => approveDoc(e)}
          style={{ color: "#52c41a", cursor: "pointer" }}
        />
        <Popconfirm
          title="Deny the task?"
          description={description}
          onConfirm={confirm}
          placement="bottom"
          okText="Yes"
          cancelText="No">
          <DislikeOutlined style={{ color: "#f5222d", cursor: "pointer" }} />
        </Popconfirm>
      </Space>
    </>
  )
}
